import "./App.css";
import { useState, useEffect } from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/home";
const testSchema = require("./assets/test_schema.json");
const themes = require("./assets/themes.json");

function NotFound() {
  return (
    <div className="not-found">
      <div className="msg">
        <h1>Nothing to see here</h1>
        <Link to="/">{`> Go Home <`}</Link>
      </div>
      <img src={require("./assets/not-found.jpg")} alt="404" />
    </div>
  );
}

function App() {
  const [schema, setSchema] = useState(null);
  const [theme, setTheme] = useState(null);

  // get schema on-load;
  useEffect(() => {
    setSchema(testSchema);
    setTheme(themes[testSchema.theme]);
    // rename browser tab
    document.title = "MyGM | " + testSchema.username;
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/gallery" exact element={<Gallery />} /> */}
          <Route
            path="/"
            exact
            element={<Home schema={schema} theme={theme} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
